export enum ITCategory {
    AnimatedVideo           = "Animated Video",
    DesktopApplication      = "Desktop Application",
    GraphicDesign           = "Graphic Design",
    MobileApp               = "Mobile Application",
    PowerPointPresentation  = "PowerPoint Presentation",
    Programming               = "Programming",
    WebApplication          = "Web Application",
    Website                 = "Website"
}

export enum ITEmailType {
    performanceAwaitingApproval = 0,
    performanceApproved = 1,
    performancePaymentAdded = 2,
    performancePaymentConfirmed = 3,
    performanceFileUploaded = 4,
    performanceSubmissionCompleted = 5,
    performanceReviewSubmitted = 6
}

export enum ITStatus {
    ProjectReviewRequired = 'Lyrics Review Required',
    SubmissionFailed = 'Submission Failed',

    // Cannot submit without uploaded file / url
    PendingCoordinatorApproval = 'Pending Coordinator Approval',
    PendingPayment = 'Pending Payment',
    PendingProject = 'Pending Project',
    PendingReview = 'Pending Review',
    SubmissionCompleted = 'Submission Completed'
}
